import GenericDialog from "./generic";
import { deviceSet } from "api/device";
import { updateSite } from "api/site";
import { DeviceSetBody, Recipients } from "api/types/device";
import { SiteUpdateBody } from "api/types/site";
import { notifySimple } from "providers/toast";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setLoading } from "store/appSlice";
import RecipientsForm, {
  RecipientsFormType,
} from "widgets/forms/sites/recipients";

const RecipientsDialog = (props: {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
  context?: "device" | "site";
  values?: Recipients[];
  id: string;
  noLevels?: number;
  readonly?: boolean;
}) => {
  const {
    isOpen,
    onClose,
    onSuccess,
    context = "device",
    values = [],
    id,
    noLevels,
    readonly = false,
  } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleSubmit = async (formData: RecipientsFormType) => {
    if (readonly) {
      onClose();
      return;
    }
    if (context === "device") {
      handleDevice(formData);
    }
    if (context === "site") {
      handleSite(formData);
    }
  };

  const handleSite = async (formData: RecipientsFormType) => {
    dispatch(setLoading(true));
    const site: SiteUpdateBody = {
      id: id,
      recipients: formData.recipients as Recipients[],
      syncRecipients: true,
    };
    const { status } = await updateSite(site);
    dispatch(setLoading(false));
    if (status === 200) {
      onSuccess();
      notifySimple(t("notification.site.recipients.success"), "success");
    } else {
      notifySimple(t("notification.site.recipients.error"), "error");
    }
  };

  const handleDevice = async (formData: RecipientsFormType) => {
    dispatch(setLoading(true));
    const updatedDevice: DeviceSetBody = {
      recipients: formData.recipients as Recipients[],
      snr: id,
    };
    const { status } = await deviceSet(updatedDevice);
    dispatch(setLoading(false));
    if (status === 200) {
      onSuccess();
      notifySimple(t("notification.device.recipients.success"), "success");
    } else {
      notifySimple(t("notification.device.recipients.error"), "error");
    }
  };

  return (
    <GenericDialog
      isOpen={isOpen}
      onExit={onClose}
      title={t("dialog.recipients.title", { context })}
      size="xl"
    >
      {!readonly && (
        <div className="pb-4 text-secondary">
          {t("dialog.recipients.description")}
        </div>
      )}

      <RecipientsForm
        values={{ recipients: values }}
        submit={handleSubmit}
        onClose={onClose}
        noLevels={noLevels}
        readonly={readonly}
      />
    </GenericDialog>
  );
};

export default RecipientsDialog;
